import { CommandItem } from "@/components/ui/command";
import { FilterOption } from "@common/utils/graphql";
import { Body } from "@hypercard/web-components";
import { Check } from "@phosphor-icons/react";

export const OptionItem = ({
  option,
  className,
  onSelect,
  value,
}: {
  option: FilterOption;
  className?: string;
  onSelect: (option: FilterOption) => void;
  value: FilterOption[];
}) => (
  <CommandItem
    value={`${option.category}-${option.id}`}
    onSelect={() => {
      onSelect(option);
    }}
    className={className}
  >
    <div className="flex w-full items-center justify-between">
      <div className="flex flex-col gap-y-1 overflow-hidden">
        <Body
          size="sm"
          weight="medium"
          className="overflow-x-hidden truncate text-ellipsis whitespace-nowrap"
        >
          {option.displayTitle}
        </Body>
        <Body size="xs" weight="medium" className="text-white/70">
          {option.displaySubtitle}
        </Body>
      </div>
      {value.find(
        (o) => o.id === option.id && o.category == option.category,
      ) && <Check weight="bold" className="mx-2 size-4 shrink-0" />}
    </div>
  </CommandItem>
);
